import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidEmail } from "@iotv/iotv-v3-types";
import { Button, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { sendRequest } from "@iotv/inter-services";
import { useReducer } from "react";
import { getProjectPrefix } from "internal-config";
const sender = `${getProjectPrefix()}UI`;
const XReducer = (prev, next) => { return { ...prev, ...next }; };
export const LNHPushNotificationTestOnly = ({}) => {
    const [state, dispatch] = useReducer(XReducer, { recipient: null, subject: null, content: null });
    const { recipient, subject, content } = state;
    const isComplete = recipient && subject && content;
    const emailIsValid = isValidEmail(recipient?.email ?? 'never');
    const handleSend = async () => {
        if (recipient && subject && content) {
            const { err, data } = await sendRequest({
                baseURL: 'https://api.dev.ssac.iotv.link/notification/send',
                method: 'POST',
                data: {
                    sender, recipient, subject, content
                }
            });
            if (err) {
                console.log(`Err sending message`, err.message);
            }
            dispatch({ subject: null, content: null });
        }
    };
    return _jsxs(Stack, { children: [_jsx(Typography, { variant: 'body1', children: "Sends a push notification to any recipient that has an email address" }), _jsx(Typography, { variant: 'caption', children: "If the email belongs to an existing user, this user is used. If the email is not known to the system an invitation to access the app is sent to the recipient by email" }), _jsx(TextField, { label: 'recipient (email)',
                value: recipient?.email ?? '',
                onChange: (e) => (dispatch({ recipient: { email: e.target.value } })) }, 'a'), _jsx(TextField, { label: 'subject',
                value: subject ?? '',
                onChange: (e) => (dispatch({ subject: e.target.value })) }, 'b'), _jsx(TextField, { label: 'context',
                value: content ?? '',
                onChange: (e) => (dispatch({ content: e.target.value })) }, 'c'), _jsx(Button, { sx: { width: 30 }, variant: 'contained', disabled: !(isComplete && emailIsValid), onClick: handleSend, children: `Send` }), !emailIsValid && _jsx(Typography, { children: "Email not valid" }), !isComplete && _jsx(Typography, { children: "Form not complete" })] });
};
